<template>
    <div class="erp-dialog">
        <el-dialog :visible="visible" title="特权维护" destroy-on-close width="800px" :close-on-click-modal='false'
            :close-on-press-escape='false' @close="handleClose">
            <div class="erp-form-box">
                <dc-form ref='dcForm' refName="customerForm" :row="addNewMainData" :config="FIELDS" label-width="100px"
                    @data-changed="handleFormDataChange" class="erp-form">
                </dc-form>
            </div>

            <span slot="footer">
                <el-button size="mini" @click="closeVisible(false)">取消</el-button>
                <el-button type="primary" size="mini" @click="confirmHandle">更新</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { ref, reactive, computed } from '@vue/composition-api';
import { formConfig } from './config.js';
import { pushAccountRecord, getPushRecordPage } from '@/modules/mdm/api/customer/customerManage.js';
import { Message } from 'element-ui';
import dcForm from '@/modules/mdm/components/form/Index.vue';
import _ from 'lodash';

export default {
    components: { dcForm },
    props: { },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const config = reactive(formConfig);
        const emit = setupContext.emit;

        const _addNewMainData = {
            originalGroupCode: '',
            isErpSynchronize: '',
            effectStatus: ''
        };
        const addNewMainData = ref(_.cloneDeep(_addNewMainData));
        const FIELDS = computed(() => {
            return config.fields;
        });

        const handleFormDataChange = ({ data, form, itemSetting }) => {
            addNewMainData.value = Object.assign(addNewMainData.value, form);
            if (itemSetting) {
                if (itemSetting.prop === 'customerAccountCode') {
                    initDialog();
                }
            }
        };

        const visible = ref(false);
        const showParams = ref({
            customerCode: ''
        });
        const show = (val) => {
            visible.value = true;
            showParams.value.customerCode = val.customerCode;
            addNewMainData.value = Object.assign({}, _addNewMainData, val);
            setupContext.root.$nextTick(() => {
                setupContext.refs.dcForm.$refs.customerForm.clearValidate();
            });
            config.fields.forEach(it => {
                if (it.prop === 'customerAccountCode') {
                    it.beforeRequest = (params) => {
                        params.customerCode = val.customerCode;
                        return params;
                    };
                }
            });
        };
        const initDialog = (val) => {
            getPushRecordPage({
                customerCode: showParams.value.customerCode,
                customerAccountCode: addNewMainData.value.customerAccountCode,
                pageNo: 1,
                pageSize: 10,
                orderBy: 'id',
                orderByType: 'desc'
            }).then(res => {
                if (res && +res.code === 0) {
                    if (Array.isArray(res.data?.list) && res.data.list.length) {
                        addNewMainData.value = res.data.list?.[0] || {};
                    } else {
                        addNewMainData.value = {};
                        Message.warning('当前业务实体暂无推送记录，请重新选择');
                    }
                }
            });
        };
        const handleClose = () => {
            visible.value = false;
        };
        const closeVisible = (val = false) => {
            visible.value = val;
        };
        const confirmHandle = () => {
            addNewMainData.value = setupContext.refs.dcForm.form;
            setupContext.refs.dcForm.validateForm().then(async () => {
                const params = _.pick(setupContext.refs.dcForm.form, ['id', 'originalGroupCode']);
                pushAccountRecord(params).then(res => {
                    if (res && +res.code === 0) {
                        Message.success('更新成功');
                    }
                }).catch(() => {
                    visible.value = false;
                }).finally(() => {
                    visible.value = false;
                });
            });
        };
        return {
            emit,
            config,
            addNewMainData,
            FIELDS,
            visible,
            closeVisible,
            confirmHandle,
            handleFormDataChange,
            show,
            handleClose
        };
    }
};
</script>
<style lang="less" scoped>
.erp-form-box{
    padding-bottom: 20px;
}
</style>
